import { render, staticRenderFns } from "./shop-form.vue?vue&type=template&id=0a581d36&scoped=true"
import script from "./shop-form.vue?vue&type=script&lang=js"
export * from "./shop-form.vue?vue&type=script&lang=js"
import style0 from "./shop-form.vue?vue&type=style&index=0&id=0a581d36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a581d36",
  null
  
)

export default component.exports